import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type NotificationType = 'success' | 'error' | 'info';

export interface AppNotification {
    id: number;
    message: string;
    type: NotificationType;
    timestamp: Date;
    /** Stable identity used to avoid pushing the same notification again (e.g. on re-navigation). Not rendered. */
    key?: string;
    /** Router link to navigate to when the notification is clicked. */
    link?: string;
}

@Injectable({
    providedIn: 'root'
})
export class NotificationCenterService {
    private readonly _notifications$ = new BehaviorSubject<AppNotification[]>([]);
    private _sequence = 0;

    get notifications$(): Observable<AppNotification[]> {
        return this._notifications$.asObservable();
    }

    push(type: NotificationType, message: string, options?: { key?: string; link?: string }): void {
        const trimmed = message?.trim();
        if (!trimmed) {
            return;
        }

        if (options?.key && this._notifications$.value.some(n => n.key === options.key)) {
            return;
        }

        const notification: AppNotification = {
            id: ++this._sequence,
            type,
            message: trimmed,
            timestamp: new Date(),
            key: options?.key,
            link: options?.link,
        };

        this._notifications$.next([notification, ...this._notifications$.value]);
    }

    clear(): void {
        this._notifications$.next([]);
    }
}
